/**
 * Google Analytics Initialization
 * 
 * This will only load GA if the REACT_APP_GA_TRACKING_ID environment variable is set.
 * Set this variable in Netlify for the live branch only to enable GA in production.
 * 
 * To enable GA: Set REACT_APP_GA_TRACKING_ID=G-SNDC8D39ED in Netlify
 * To disable GA: Remove the environment variable or leave it empty
 */

export const initializeGA = () => {
  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;

  // Only initialize if tracking ID is provided
  if (!trackingId) {
    console.log('Google Analytics: Tracking ID not found. GA will not be loaded.');
    return;
  }

  // Load Google Tag Manager script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script1);

  // Initialize dataLayer and gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', trackingId);

  // Make gtag globally accessible
  window.gtag = gtag;

  console.log(`Google Analytics: Initialized with tracking ID ${trackingId}`);
};
